"use client";
import classNames from "classnames";
import Link from "next/link";
import Image from "next/legacy/image";

import {
  Header,
  HeaderLeftContent,
  HeaderCenterContent,
  HeaderContainer,
} from "@stadium/ui/src/components/header";
import { ThreeProgressiveDots } from "@stadium/ui/src/components/loaders/loaders";
import WeglotDropdown from "@stadium/ui/src/components/weglot-dropdown";
import UnAuthenticatedRightSection from "@stadium/shared/src/components/header/unauthenticated-right-section";
import PrismicHeaderLinks from "@stadium/shared/src/components/header/unauthenticated-dd-links";

import { useJuneSoEventTracker } from "@stadium/services/june-analytics";

import { STADIUM } from "@stadium/ui/src/components/brands/all/constants";
import { DASHBOARD_ROUTE } from "@stadium/shared/src/constants/routes";
import { HEADER_LINKS_SERVICES, STADIUM_NAVBAR } from "@stadium/shared/src/constants/june-so";

import styles from "./main.module.scss";

const LoggedOutWebStadiumHeader = ({
  isWeglotDropDown = false,
  isLoading = false,
  loginOptions,
  headerLogoLink,
  isMarketingPage = false,
}) => {
  const { trackEvent } = useJuneSoEventTracker({
    services: HEADER_LINKS_SERVICES,
    elementPosition: STADIUM_NAVBAR,
  });

  const renderUnauthenticatedRightSection = () => {
    if (isLoading) {
      return <ThreeProgressiveDots />;
    }

    return (
      <UnAuthenticatedRightSection loginOptions={loginOptions} isMarketingPage={isMarketingPage} />
    );
  };

  const renderLeftLogoLinks = () => (
    <HeaderLeftContent className={isMarketingPage ? styles.stadiumLogoBlockMarketing : ""}>
      <span className={`${styles.headerLogoHolder} ${styles.stadiumLogoBlock}`}>
        <Link
          href={headerLogoLink || DASHBOARD_ROUTE}
          passHref
          onClick={() => trackEvent({ target: "stadium-logo" })}
        >
          <Image src={STADIUM.logo2} height={32} width={132} alt={STADIUM.imgAlt} />
        </Link>
      </span>
    </HeaderLeftContent>
  );

  return (
    <HeaderContainer className={styles.loggedOutPrimaryHeader}>
      <Header level={1} className={styles.loggedOutPrimaryHeaderContainer}>
        <div className={`${styles.primaryHeaderRow} ${isMarketingPage ? styles.primaryHeaderRowNew : ""}`}>
          {renderLeftLogoLinks()}
          <div className={styles.headerTabsSection}>
            <HeaderCenterContent
              className={classNames(styles.headerTabContent, {
                [styles.headerTabContentNew]: isMarketingPage,
              })}
            >
              <PrismicHeaderLinks isMarketingPage={isMarketingPage} />
            </HeaderCenterContent>
          </div>
          {isWeglotDropDown && <WeglotDropdown />}
          {renderUnauthenticatedRightSection()}
        </div>
      </Header>
    </HeaderContainer>
  );
};

export default LoggedOutWebStadiumHeader;
